// S0 — Announcement bar above the navigation. Fixed at top-0 z-60.
// Free & Open plan: rotates between the site tagline and the AI-transparency note.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Bot } from 'lucide-react';

const MESSAGES = [
  {
    icon: Sparkles,
    bold: 'LearnixTa:',
    short: ' Pre-career clarity previews — free.',
    long: ' Pre-career clarity previews — every career in a detailed, future-ready way. 100% free.',
    cta: '/dashboard',
    ctaText: 'Start exploring →',
    bg: '#1D9E75',
    testid: 'announcement-tagline',
  },
  {
    icon: Bot,
    bold: 'AI-assisted:',
    short: ' AI helps organize this info — verify key facts.',
    long: ' LearnixTa uses AI to organize and explain career info. AI can make mistakes — verify eligibility, exams, fees and salaries on official sources.',
    cta: '/ai-disclaimer',
    ctaText: 'Read more →',
    bg: '#8A5A00',
    testid: 'announcement-ai-note',
  },
];

const AnnouncementBar = () => {
  const [idx, setIdx] = useState(0);
  // Tells the sealed-header CSS (--lxt-ann-h) to shift the docked navbar
  // and sticky pill rows down by the bar's 36px height on this page.
  useEffect(() => {
    document.documentElement.classList.add('lxt-has-announcement');
    return () => document.documentElement.classList.remove('lxt-has-announcement');
  }, []);
  useEffect(() => {
    const iv = setInterval(() => setIdx((i) => (i + 1) % MESSAGES.length), 7000);
    return () => clearInterval(iv);
  }, []);
  const m = MESSAGES[idx];
  const Icon = m.icon;
  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] w-full text-white text-sm font-medium transition-colors duration-500"
      style={{ background: m.bg }}
      data-testid="announcement-bar"
    >
      <div className="max-w-7xl mx-auto px-4 h-9 flex items-center justify-center gap-2 sm:gap-3 whitespace-nowrap overflow-hidden">
        <Icon size={14} className="shrink-0" />
        <span className="truncate" data-testid={m.testid}>
          <span className="font-bold">{m.bold}</span>
          <span className="sm:hidden">{m.short}</span>
          <span className="hidden sm:inline">{m.long}</span>
        </span>
        <Link
          to={m.cta}
          className="lxt-glow-cta shrink-0 inline-flex items-center gap-1 rounded-full px-3 py-1 -my-1 underline underline-offset-4 decoration-white/60 hover:decoration-white font-semibold"
          data-testid="announcement-cta"
        >
          {m.ctaText}
        </Link>
      </div>
    </div>
  );
};

export default AnnouncementBar;
